import { observable } from 'mobx';
import { constants } from 'utils/constants';

const ONE_TIME_NOTIFICATION_TYPES = {
  [constants.ALERT_SUBSCRIPTION_ENDS]: true
};

class UserNotifications {
  @observable _notifications = [];

  getAll() {
    return this._notifications;
  }

  getOneTimeNotifications() {
    const result = [];
    for (let i = this._notifications.length - 1; i >= 0; i--) {
      const notification = this._notifications[i];

      if (ONE_TIME_NOTIFICATION_TYPES[notification.actionId]) {
        result.push(notification);
        this._notifications.splice(i, 1); // remove the notification from array, so it doesn't show up next time
      }
    }

    return result;
  }

  getNotificationsForDisplay() {
    return this.getOneTimeNotifications().concat(this.getAll());
  }

  update(notifications) {
    this._notifications = notifications;
  }
}

export default UserNotifications;



// WEBPACK FOOTER //
// ./src/stores/UserNotifications.js